import React from "react";
import { TemplateEditorProps, templateImageUrl } from "../utils/templatePageForm";
import { Stack, Textarea, TextInput } from "@mantine/core";
import ImageDropzoneField from "./ImageDropzoneField";

const InviterTemplateEditor: React.FC<TemplateEditorProps> = ({
  form,
  images,
  onUploadImage,
  onClearImage,
}) => {
  const templateType = form.values.template_type

  return (
    <Stack gap="lg">
      <TextInput
        label="キャンペーン管理用の概要を設定してください"
        {...form.getInputProps('pageDescription')}
      />

      <ImageDropzoneField
        label="キービジュアルとして表示する画像ファイルを設定してください"
        description="※高さ500ピクセルに合わせて中央に表示されます。440×560ピクセル以上のjpgまたはpng画像を選択してください"
        value={form.values.key_visual}
        uploaded={images.KEY_VISUAL}
        defaultUrl={templateImageUrl(templateType, 'img_kv.png')}
        onDrop={(files) => onUploadImage('KEY_VISUAL', files)}
        onClear={() => onClearImage('KEY_VISUAL')}
        error={form.errors.key_visual}
        dataPath="key_visual"
      />

      <Textarea
        label="キャッチコピーの文章を30文字以内で設定してください"
        rows={4}
        {...form.getInputProps('key_visual_text')}
      />
    </Stack>
  )
}

export default InviterTemplateEditor
